import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { DepartmentModel } from '../storeModels/department.model';


export const UPDATE_ALL_INFO = '[ALL] Update';


export const REMOVE_ALL_INFO = '[ALL] Remove';

export class UpdateAllInfo implements Action {
    readonly type = UPDATE_ALL_INFO;
    constructor(public payload: DepartmentModel) {}
}
export class RemoveAllInfo implements Action {
    readonly type = REMOVE_ALL_INFO;
}


export type Actions = 
    UpdateAllInfo
  | RemoveAllInfo    
